import React, {Component} from 'react';
import {FOOTER_TITLE, FOOTER_APP_TEXT} from '../../constants';
import './footer.css';
import AppStore from '../AppStore/AppStore';
import Copyright from '../Copyright/Copyright';
import phone from './footer-phone.svg';
import Logo from '../Logo/Logo';

class Footer extends Component {
	render() {
		return (
			<footer className="footer">
				<div className="footer__outer">
					<div className="footer__inner">
						<div className="wrapper">
							<Logo modifier="footer"/>
							<h3 className="footer__title">{FOOTER_TITLE}</h3>
							<div className="footer__app-text">{FOOTER_APP_TEXT}</div>
							<AppStore size="big"/>
							<Copyright/>
							<img src={phone} className="footer__phone" alt="footer phone"/>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js